import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import DefaultCell from "./DefaultCell/DefaultCell";

const styles = () => ({
  redBackground: {
    backgroundColor: "#FDEDED !important"
  },
  tableRowOverride: {
    backgroundColor: "#fff"
  },
  pulseHighlight: {
    animation: "$backgroundHighlightFade 10s"
  },
  blueHighlight: {
    backgroundColor: "#e6f4ff !important"
  },
  "@keyframes backgroundHighlightFade": {
    "0%": {
      backgroundColor: "#fff"
    },
    "15%, 70%": {
      backgroundColor: "#e6f4ff"
    },
    "100%": {
      backgroundColor: "#fff"
    }
  },
  preventWrap: {
    whiteSpace: "nowrap"
  },
  wrapAll: {
    wordBreak: "break-all"
  },
  wrapWord: {
    wordBreak: "break-word"
  },
  wrapNone: {
    wordBreak: "keep-all"
  }
});

const OSSTableRow = ({ classes, config = {}, row }) => {
  const {
    columns,
    onHighlightRowComplete = null,
    preventTableCellContentWrap = false,
    TableRowProps,
    TableRowClickHandler = () => {},
    refetchHandler = () => {}
  } = config;

  const onAnimationEnd = ({ animationName }) => {
    if (animationName === "backgroundHighlightFade") {
      onHighlightRowComplete();
    }
  };

  return (
    <TableRow
      className={`${row.pulse && classes.pulseHighlight} ${
        row.shouldHighlightRowError ? classes.redBackground : ""
      }`}
      classes={{
        root: classes.tableRowOverride,
        selected: classes.blueHighlight
      }}
      onAnimationEnd={onAnimationEnd}
      selected={row.highlight}
      {...TableRowProps}
      onClick={() => TableRowClickHandler(row)}
    >
      {columns.map((column, index) => (
        <TableCell
          {...column.TableCellProps}
          key={index}
          className={[
            preventTableCellContentWrap ? classes.preventWrap : "",
            column?.TableCellProps?.className
              ? column.TableCellProps.className
              : "",
            column?.wrapAll && classes.wrapAll,
            column?.wrapWord && classes.wrapWord,
            column?.wrapNone && classes.wrapNone
          ].join(" ")}
        >
          {OSSTableRow.Cell(column, row, refetchHandler)}
        </TableCell>
      ))}
    </TableRow>
  );
};

OSSTableRow.Cell = (column, row, refetchHandler) => {
  // If `renderCell` is defined, use it to render the cell content
  if (column.renderCell) {
    return column.renderCell(row, refetchHandler);
  }

  // Fallback to existing logic using `cell` prop
  const { cell } = column;
  const validCell = React.isValidElement(cell) ? cell : <DefaultCell />;
  return React.cloneElement(validCell, { column, row });
};

OSSTableRow.propTypes = {
  classes: PropTypes.object.isRequired,
  config: PropTypes.shape({
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    onHighlightRowComplete: PropTypes.func
  }).isRequired
};

export default withStyles(styles)(OSSTableRow);
